import { DatePicker, DatePickerChangeEvent } from "@progress/kendo-react-dateinputs";
import * as React from "react";
import "./TableDateRangeFilter.css";

interface ITableDateRangeFilterProps {
    onChange: (startDate: Date | null, endDate: Date | null) => void;
    startDate: Date | null;
    endDate: Date | null;
    small?: boolean;
}

function TableDateRangeFilter(p: ITableDateRangeFilterProps) {

    return (
        <div className={`input-group mb-1 table-date-range-filter ${p.small ? "sm" : ""}`}>
            <DatePicker data-id="startDate" onChange={updateStartDate} value={p.startDate} className="" formatPlaceholder="short" />
            <span className="date-separator">&minus;</span>
            <DatePicker data-id="endDate" onChange={updateEndDate} value={p.endDate} className="" formatPlaceholder="short" />
        </div>
    );

    function updateStartDate(event: DatePickerChangeEvent) {
        p.onChange(event.value, p.endDate);
    }

    function updateEndDate(event: DatePickerChangeEvent) {
        p.onChange(p.startDate, event.value);
    }
}

export default TableDateRangeFilter;



// WEBPACK FOOTER //
// ./src/core/TableDateRangeFilter/TableDateRangeFilter.tsx